module.exports = __webpack_public_path__ + "c834d83f15911fd62427398b9e3e12dc.jpg";


//////////////////
// WEBPACK FOOTER
// ./assets/images/photo-backgrounds/animals/Elephant2.jpg
// module id = 3465
// module chunks = 0